import React from 'react';
import {Modal} from 'react-bootstrap';
import './styles.scss';

export default function AppModal({show, onHide, title, children, size, closeOnBackdropClick = true, showCloseButton = true}) {
  return (
    <Modal show={show} onHide={onHide} backdrop={closeOnBackdropClick ? true : 'static'} keyboard={closeOnBackdropClick} dialogClassName="app-modal" size={size}>
      <Modal.Header>
        {showCloseButton && <button className="app-modal__close" onClick={onHide} aria-label={Drupal.tt('Chiudi')}>✕</button>}
        {title && <Modal.Title>{title}</Modal.Title>}
      </Modal.Header>
      <Modal.Body>{children}</Modal.Body>
    </Modal>
  );
}
